import { FC, useEffect, useState } from "react";
import { Model } from "../models/Model";
import { ConstructorOf } from "../mvvm/core";

export function withModel<T extends Model, P extends Object = {}>(
  Component: FC<{ model: T } & P>,
  Model: ConstructorOf<T>
) {
  return (props: P) => {
    // Nowa instancja modelu PER MOUNT — inaczej współdzielony singleton trzyma dane poprzedniego
    // użytkownika po przelogowaniu, a onInit (fetch) odpala się tylko raz, na zawsze.
    const [model] = useState(() => new Model());

    // onInit po zamontowaniu (gdy token jest już ustawiony) — i ponownie przy każdym kolejnym mountcie.
    useEffect(() => {
      model.onInit();
    }, [model]);

    return <Component model={model} {...props} />;
  };
}
